
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";
import { successAlert, warnAlert } from "../../../components/alert/defaultAlert";
import axiosInstance from "../../../../services/AxiosInstance";

const StockhNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        product: Yup.object().nullable().required(t('validation.required.product')),
        branch: Yup.object().nullable().required(t('validation.required.branch')),
        currentStock: Yup.string().required(t('validation.required.product')),
        minStockLevel: Yup.string().required(t('validation.required.min_stock_level')),
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {},
        validationSchema: formSchema,
        onSubmit: values => {
            
            // Verifica se o estoque mínimo foi informado.
            if (values.minStockLevel === null || values.minStockLevel === '' || values.minStockLevel === 0) {
                warnAlert(t('validation.required.min_stock_level'));
                formik.setSubmitting(false);
                return;
            }

            let id = getId(entityData);
            let payload = {
                minStockLevel: values.minStockLevel
            }

            axiosInstance.patch(`${Api.stock_control.stock}/${id}/data`, payload)
                .then(() => {
                    successAlert(t('message.operation_successfully'), () => {
                        navigate(MenuConfig.stock_control.stock.route);
                    });
                })
                .catch(error => ApiError(error));
        }
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('stock_management')}
                childMenu={t('check_stock')}
                activeMenu={t('update')}
                child={
                    <Form
                        formik={formik}
                        status={status}
                        setStatus={setStatus}
                        entityData={entityData}
                    />
                }
                setEntityData={setEntityData}
                path={Api.stock_control.stock}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.stock_control.stock.route}
            />
        </>
    );
}

export default StockhNew;